import Typography from "@mui/material/Typography";
import styled from "../../util/styled";

export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
})) as typeof Typography;
